import React from "react";
import ImageIcon from "@material-ui/icons/ImageOutlined";
import { useDispatch } from "react-redux";
import { getTab } from "../../actions/activeTab";

function SideBar(props) {
  const dispatch = useDispatch();

  return (
    <div className="admin-sidebar shadow">
      <img
        className="ski-admin-logo"
        src="/Images/ski-admin-logo.png"
        alt="SKi Creative Studio logo"
      />
      <div className="nav-container">
        <div className="nav-tag">General</div>
        <div className="nav-items">
          <div
            onClick={() => dispatch(getTab("clients"))}
            className={`${
              props.active === "clients" ? "active" : ""
            } nav-item client-item`}
          >
            <ImageIcon /> <b>Clients</b>
          </div>
          <div
            onClick={() => dispatch(getTab("creatives"))}
            className={`${
              props.active === "creatives" ? "active" : ""
            } nav-item creatives-item`}
          >
            <ImageIcon /> <b>Creatives</b>
          </div>
          <div
            onClick={() => dispatch(getTab("updateOrder"))}
            className={`${
              props.active === "updateOrder" ? "active" : ""
            } nav-item update-order-item`}
          >
            <ImageIcon /> <b>Update Order</b>
          </div>
          <div
            onClick={() => dispatch(getTab("content"))}
            className={`${
              props.active === "content" ? "active" : ""
            } nav-item content-item`}
          >
            <ImageIcon /> <b>Content</b>
          </div>
        </div>
      </div>
      <button
        style={{ backgroundColor: "#1D8CFB", outline: "none", border: "none" }}
        className="admin-logout-btn btn btn-primary shadow-sm btn-sm mx-3 mt-3 w-75"
        onClick={() => {
          localStorage.removeItem("skiUserToken");
          window.location.reload();
        }}
      >
        Log Out
      </button>
    </div>
  );
}

export default SideBar;
